module.exports = __webpack_public_path__ + "resources/img-loading.6682c8b3bb26eb2e.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/image/img/img-loading.png
// module id = 682
// module chunks = 0 1 2 3